import type { CardType } from "metabase-types/api";

export const InsightsUpsellTab = (_props: {
  /** 'Model' in the sense of 'type of thing', not in the sense of 'dataset' */
  model: "dashboard" | CardType;
}) => {
  // IAS overlay: no premium-plan promo CTAs.
  return null;
};
